//React lib
import { Box, Grid } from "@mui/material";
//Third party component
import { useTranslation } from "react-i18next";
//Internal component
import ActionButton from "../../component/ActionButton";
// Icon
import good from "../../assets/images/feedback/good.svg";
import average from "../../assets/images/feedback/average.svg";
import veryGood from "../../assets/images/feedback/very-good.svg";
import excellent from "../../assets/images/feedback/excellent.svg";
import notSatified from "../../assets/images/feedback/not-satisfied.svg";
import good_gray from "../../assets/images/feedback/good_gray.svg";
import average_gray from "../../assets/images/feedback/average_gray.svg";
import veryGood_gray from "../../assets/images/feedback/very-good_gray.svg";
import excellent_gray from "../../assets/images/feedback/excellent_gray.svg";
import notSatified_gray from "../../assets/images/feedback/not-satisfied_gray.svg";
import { useState } from "react";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";
import { useAppDispatch } from "../../store/hooks";
import GlobalLoader from "../../component/GlobalLoader";
import Toaster from "../../component/Toaster";
import { LoginUserDetails } from "../../util/Utils";

interface feedbackProps {
  feedbackList: any;
  close: any;
}

export default function Feedback(props: feedbackProps) {
  const { feedbackList, close } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const currentFranchiseeId = LoginUserDetails.getUserDetails()?.franchiseeId;
  const [spinner, setSpinner] = useState<boolean>(false);
  const emojiArray = [notSatified, average, good, veryGood, excellent];
  const emojiGrayArray = [
    notSatified_gray,
    average_gray,
    good_gray,
    veryGood_gray,
    excellent_gray,
  ];
  let feedbackRatingArray: any = [];

  const clearFeedback = () => {
    feedbackList.FeedbackList?.forEach((item: any) => {
      delete item.rating;
    });
    setRatingArray([]);
    console.log(feedbackList.FeedbackList);
  };

  const submitFeedback = () => {
    console.log(feedbackRatingArray + "emojiArray");
    setSpinner(true);
    dispatch(
      dashboardAction({
        apiAction: "submitFeedback",
        formValues: preApiRequest(),
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result.payload.data.message);
          close();
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  const preApiRequest = () => {
    let feedbackReqArray: any = [];
    feedbackList?.FeedbackList?.forEach((item: any) => {
      feedbackReqArray.push({
        feedbackId: item.id,
        rating: item.rating,
        franchiseeId: currentFranchiseeId,
      });
    });
    return feedbackReqArray;
  };
  const [ratingArray, setRatingArray] = useState<any>([]);
  let ratingSubArray: any = [];
  const rating = (index: number) => {
    ratingSubArray[index] = index;
    setRatingArray(ratingSubArray);
  };

  return (
    <div>
      <div>
        <Box className="full">
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            {feedbackList?.FeedbackList?.map((feedback: any, index: number) => {
              return (
                <>
                  <Grid item xs={12} sm={6} md={6} lg={8}>
                    <div className="font-14 margin-up-10">
                      {`${index + 1}) ${feedback.feedback}`}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <div className="flex-gap center-end margin-up-10">
                      {emojiArray?.map((emoji: any, emojiIndex: number) => {
                        return (
                          <>
                            <div
                              className="pointer"
                              onClick={
                                feedback.feedback
                                  ? () => {
                                      feedback["rating"] = emojiIndex;
                                      rating(index);
                                      feedbackRatingArray[index] = feedback;
                                    }
                                  : () => {}
                              }
                            >
                              <img
                                src={
                                  feedback.rating === emojiIndex
                                    ? emoji
                                    : emojiGrayArray[emojiIndex]
                                }
                                alt={""}
                              />
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </Grid>
                </>
              );
            })}
          </Grid>
          <div className="border-top padding-up-15 center-end flex-gap margin-down-5">
            <ActionButton
              disabled={
                !feedbackList?.FeedbackList?.some(
                  (item: any) => item.rating > -1
                )
              }
              label={t("clear")}
              actionButtonStyle="outline"
              onClick={() => {
                clearFeedback();
              }}
            ></ActionButton>
            <ActionButton
              disabled={
                !feedbackList?.FeedbackList?.every(
                  (item: any) => item.rating > -1
                )
              }
              label={t("submit")}
              onClick={() => {
                submitFeedback();
              }}
            ></ActionButton>
          </div>
        </Box>
        <GlobalLoader loading={spinner} />
      </div>
    </div>
  );
}
